// @ts-nocheck 2ea71320
import createTimetableWidget from './createTimetableWidget';
export default ({ editorAPI }) =>
  createTimetableWidget({
    editorAPI,
  });
